// extracted by mini-css-extract-plugin
export default {"svg":"grUPq","bar":"r-4XX","container":"-S3+0","oldIcon":"KkZGi","newIcon":"BmfR0"};